import React, { useRef, useState, useEffect } from 'react';

const DraggableCardContainer = ({ children, className = "" }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleMouseMove = (e) => {
      const rect = container.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      
      container.style.setProperty("--mouse-x", `${x}px`);
      container.style.setProperty("--mouse-y", `${y}px`);
      container.classList.add("is-hovering");
    };
    
    const handleMouseLeave = () => {
      container.classList.remove("is-hovering");
    };

    container.addEventListener("mousemove", handleMouseMove);
    container.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      container.removeEventListener("mousemove", handleMouseMove);
      container.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, []);

  return (
    <div ref={containerRef} className={`draggable-card-container relative ${className}`}>
      {children}
    </div>
  );
};

// This component remains mostly for the 3D transform
const DraggableCardBody = ({ children, rotateX, rotateY }) => {
  return (
    <div
      className="relative w-full h-full transition-transform duration-500 ease-[cubic-bezier(0.23,1,0.32,1)]"
      style={{
        transform: `perspective(1200px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`,
        transformStyle: 'preserve-3d',
      }}
    >
      {children}
    </div>
  );
};

// This container handles the local 3D tilt and displays the glow
const Container = ({ children }) => {
  const [rotateX, setRotateX] = useState(0);
  const [rotateY, setRotateY] = useState(0);

  const handleMouseMove = (e) => {
    const card = e.currentTarget;
    const rect = card.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const centerX = rect.width / 2;
    const centerY = rect.height / 2;
    const rotateXValue = ((y - centerY) / centerY) * -8;
    const rotateYValue = ((x - centerX) / centerX) * 8;
    
    setRotateX(rotateXValue);
    setRotateY(rotateYValue);
  };

  const handleMouseLeave = () => {
    setRotateX(0);
    setRotateY(0);
  };
  
  // Clone the child (DraggableCardBody) to pass rotation props
  const childWithProps = React.Children.map(children, child => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { rotateX, rotateY });
    }
    return child;
  });

  return (
    <div
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      className="aceternity-glow-container relative flex items-center justify-center rounded-lg bg-gray-200 dark:bg-gray-400 p-1 transition-transform duration-300 ease-in-out hover:scale-105"
    >
      {childWithProps}
    </div>
  );
};

export { DraggableCardContainer, DraggableCardBody, Container };